import { AppText } from '../../components/AppText';
import { PrimaryButton } from '../../components/PrimaryButton';
import { Strings } from '../../strings';

import { useSettings } from './useSettings';

/**
 * design-system/08-Screens.md §1 — account, language, subscription, sign out.
 * Mirrors android/…/Screens/Settings/SettingsScreen.kt.
 *
 * The subscription row states plainly that nothing is charged. Hiding it would be the easier choice and
 * the wrong one: a parent deciding whether to invest ten minutes a day deserves to know the commercial
 * position rather than discover it later (R0001 D-12).
 */
export function SettingsScreen({ email, onSignOut }: { email: string; onSignOut: () => void }) {
  const model = useSettings(email);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
      <AppText as="h1" style="titleL">
        {Strings.navSettings}
      </AppText>

      <SettingRow label={Strings.settingsAccount} value={model.state.email} />
      <SettingRow label={Strings.settingsLanguage} value={Strings.settingsLanguageValue} />
      <SettingRow label={Strings.settingsSubscription} value={Strings.settingsSubscriptionNote} />

      <PrimaryButton label={Strings.actionSignOut} onClick={onSignOut} />
    </div>
  );
}

function SettingRow({ label, value }: { label: string; value: string }) {
  return (
    <div
      style={{
        borderRadius: 'var(--radius-m)',
        background: 'var(--surface-raised)',
        padding: 'var(--space-4)',
      }}
    >
      <AppText style="label" color="var(--text-secondary)">
        {label}
      </AppText>
      <AppText>{value}</AppText>
    </div>
  );
}
